/*
 * Seats manager for handling selected seats for Ticket buyer and Cash orders
 * */
(function () {
  var ticketbuyerSeatsManager = seatsManager({
    initialize: function (config) {
      var itemTypes = config.data.item_types;
      // create html for ticket types select
      var select = $("<select class='ticket-types-select' />");
      var currencySymbol = $("body").attr("data-currency-symbol") || "";
      if (currencySymbol == "") {
        console.error("BODY tag doesn't contain currency symbol");
      }
      select.append(config.ticketBlankOptionTemplate);

      for (var id in itemTypes) {
        $(
          "<option value='" +
            itemTypes[id].id +
            "'>" +
            itemTypes[id].title +
            ", " +
            itemTypes[id].price +
            "</option>"
        ).appendTo(select);

        if (itemTypes[id].up_sellings && itemTypes[id].up_sellings.length) {
          config.ticketsUpSelling[itemTypes[id].id] = itemTypes[id].up_sellings;
        }
      }

      config.$form.on("change", ".ticket-types-select", function (e) {
        config.actions.checkIfTicketHasEmptyValue();
      });

      var getOrderAmountSelect = function (modelId) {
        var $template = $(
            "<div><select name='item_type[" +
              modelId +
              "]' data-model-id='" +
              modelId +
              "'></select></div>"
          ),
          $select = $template.find("select");
        for (var i = 0; i <= 10; i++) {
          $select.append("<option value'" + i + "'>" + i + "</option>");
        }
        $select.val($select.find("option:first").val());
        return $template.html();
      };

      var getPriceTitle = function (item) {
        var total = (parseFloat(item.price) + parseFloat(item.fee)).toFixed(2);
        var template = $(
          "<div><ul class='ticket-price-detailed'>" +
            "<li>Price:<em>" +
            parseFloat(item.price).toFixed(2) +
            currencySymbol +
            "</em></li>" +
            "<li>Fee: <em>" +
            parseFloat(item.fee).toFixed(2) +
            currencySymbol +
            "</em></li>" +
            "<li>Total: <em>" +
            total +
            currencySymbol +
            "</em></li>" +
            "</ul></div>"
        );
        return template.html();
      };

      var ticketTypesSelectHandler = function (ticket) {
        var value = ticket.find("select.ticket-types-select").val();
        ticket.find(".upselling-container").remove();
        if (config.ticketsUpSelling[value]) {
          var $upsellingContainer = $(
            "<div class='upselling-container ticket_types' />"
          );
          ticket.append($upsellingContainer);

          $(config.ticketsUpSelling[value]).each(function (index, item) {
            $upsellingContainer.append(
              "<div class='upselling-item ticket_type row-fluid item_type'>" +
                "<div class='desc span6'>" +
                item.type +
                "<label><h4>" +
                item.title +
                "</h4></label>" +
                "</div>" +
                "<div class='price span3'><a data-original-title='" +
                getPriceTitle(item) +
                "' data-class='order-tooltip' data-container='#new_order' data-html='true' data-placement='bottom' data-toggle='tooltip' rel='tooltip'>" +
                item.price +
                "<i class='t-icon-info-sign'></i></a></div>" +
                "<div class='span3'>" +
                getOrderAmountSelect(item.id) +
                "</div>" +
                "</div>"
            );
            $upsellingContainer.find("[rel=tooltip]").tooltip();
          });
        }
      };

      config.ticketTypeSelector = select.get(0).outerHTML;
      ticketTypesSelectHandler(select.parents("li"));

      // listen for a click event on remove button
      config.$form.on("click", "em", function (event) {
        var ticket = $(event.target).parents("li");
        config.actions.remove(ticket.data("row"), ticket.data("coll"));
      });

      // Go to the next step by submitting form or changing tickets
      config.$form.submit(function (event) {
        var data = {};
        var sectionId = config.$form.attr("data-section-id");

        $(this)
          .find("li")
          .each(function () {
            var selectedTicket = $(this),
              selectedTicketType = $(this).find("option:selected").val();

            data[selectedTicketType] = data[selectedTicketType] || {
              amount: 0,
              details: [],
            };
            data[selectedTicketType].amount += 1;
            data[selectedTicketType].details.push({
              seat: selectedTicket.data("coll"),
              row: selectedTicket.data("row"),
              section_id: parseInt(config.$form.attr("data-section-id")),
            });

            selectedTicket.find(".upselling-item").each(function () {
              var subselectedItem = $(this).find("select"),
                subselectedItemType = subselectedItem.data("model-id");

              data[subselectedItemType] = data[subselectedItemType] || {
                amount: 0,
                details: [],
              };
              var amount = 0;
              amount = parseInt(subselectedItem.val(), 10);
              data[subselectedItemType].amount += amount;
              for (var i = 0; i < amount; i++) {
                data[subselectedItemType].details.push({
                  seat: parseInt(selectedTicket.data("coll")),
                  row: parseInt($(selectedTicket).data("row")),
                });
              }
            });
          });

        for (var orderId in data) {
          var orderLine = data[orderId],
            $orderLine = config.$form.find(
              "[data-ticket-type-id='" + orderId + "']"
            );

          $orderLine.find("[data-type='amount']").val(orderLine.amount);
          $orderLine
            .find("[data-type='seatings']")
            .val(JSON.stringify(orderLine.details));
        }
        $.ajax({
          url: this.action,
          data: config.$form.serialize(),
          type: "POST",
          dataType: "script",
        });

        return false;
      });
    },
    add: function (config, row, coll, type, itemTypes, uuid) {
      var ticketTypesLength = $(config.ticketTypeSelector).children(
        "option"
      ).length;

      function removeUnavailableTicketTypes(
        ticketTypes,
        availableTicketTypeIds
      ) {
        var $options = $(ticketTypes)
          .find("option")
          .filter(function () {
            var ticketTypeId = parseInt($(this).attr("value"), 10);
            return availableTicketTypeIds.indexOf(ticketTypeId) !== -1;
          });
        return $(ticketTypes)
          .empty()
          .append(ticketTypesLength > 1 ? config.ticketBlankOptionTemplate : "")
          .append($options)
          .val("");
      }

      function selectDefaultTicketType(selector) {
        var $options = selector.find("option");
        var getAttrValue = tc.dom.getAttr("value");
        var availableIds = R.pipe(
          tc.dom.toArray,
          R.map(getAttrValue)
        )($options);
        var defaultId = config.$form.attr("data-item-type-id");
        // If availableTickes contain defaultId set it as itemId
        // otherwise if there are only one ticket set it
        var itemTypeId =
          (R.contains(defaultId, availableIds) && defaultId) ||
          (availableIds.length == 2 && R.last(availableIds));

        if (itemTypeId) {
          selector.val(itemTypeId);
        }
        return selector;
      }

      //  processItemTypesOptions -> $Element -> [] -> $Element
      var processItemTypesOptions = R.pipe(
        removeUnavailableTicketTypes,
        selectDefaultTicketType
      );

      var ticketHtml = config.ticketFieldTemplateSelected(row, coll);
      config.tickets[row + "||" + coll] = $(ticketHtml)
        .append(processItemTypesOptions(config.ticketTypeSelector, itemTypes))
        .hide()
        .appendTo(config.ticketsList)
        .slideDown(200)
        .data("row", row)
        .data("coll", coll)
        .data("area_uuid", uuid);

      config.$form
        .find(".tickets-amount em")
        .html(config.ticketsList.children().length);

      // (ticketTypesLength > 1) && config.submitBtn.prop('disabled', true);
      config.actions.checkIfTicketHasEmptyValue();
    },
    update: function (config, obj) {
      var ticketData = obj.item_types.reduce(function (acc, cur) {
        acc[cur.id] = cur;
        return acc;
      }, {});
      var itemTypeFactoryWithData = config.helpers.itemTypeFactory(ticketData);
      var selectedSeatsKeys = Object.keys(config.tickets);

      obj.seating_arrangements.seats
        .filter(config.helpers.selectedSeatsFilterer(selectedSeatsKeys))
        .forEach(function (seat) {
          var key = config.helpers.seatToKey(seat.row, seat.seat);
          var ticketForm = config.tickets[key];
          var $ticketFormItemTypeSelect = ticketForm.find("select");
          var concreteItemTypeFactory = itemTypeFactoryWithData(
            $ticketFormItemTypeSelect
          );

          var ticketFormItemTypeOptionIds = $ticketFormItemTypeSelect
            .find("option")
            .map(config.helpers.$propInt("value"))
            .get();

          seat.item_type_ids
            .filter(function (id) {
              return ticketFormItemTypeOptionIds.indexOf(id) === -1;
            })
            .forEach(concreteItemTypeFactory);
        });

      obj.seating_arrangements.areas.forEach(function (area) {
        area.item_type_ids.forEach(function (ticket_type) {
          var $ticketFormItemTypeSelect = $("#ticket_type_" + ticket_type).find(
            "select"
          );
          $ticketFormItemTypeSelect.empty();
          for (var i = 0; i <= 10; i++) {
            $ticketFormItemTypeSelect.append(
              "<option val='" + i + "'>" + i + "</option>"
            );
          }
          $ticketFormItemTypeSelect.attr("disabled", false);
        });
      });

      obj.promo_codes.forEach(function (promocode) {
        var itemId = promocode.item_type_id;
        var promoCodeName = promocode.name;
        var $ticketFormItemTypes = [
          $("#ticket_type_" + itemId),
          config.$form.find("[data-ticket-type-id='" + itemId + "']"),
        ];
        $.each($ticketFormItemTypes, function (i, val) {
          $(val)
            .find("input[type='hidden'][name*='[promo_code_name]']")
            .val(promoCodeName);
        });
      });
    },
    remove: function (config, row, coll) {
      var ticket = $(config.tickets[row + "||" + coll]);
      if (ticket.length > 0) {
        ticket.fadeOut(200, function () {
          $(this).remove();
          // update tickets amount
          config.$form
            .find(".tickets-amount em")
            .html(config.ticketsList.children().length);
          config.actions.checkIfTicketHasEmptyValue();
        });
        config.$form.trigger("seat:remove", [[row, coll]]);
      }
    },
  });

  window.ticketbuyerSeatsManager = ticketbuyerSeatsManager;
})();
